// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectAllCreditMemoDealers = dealers => ({
    dealers,
    type: actions.SELECT_ALL_CREDIT_MEMO_DEALERS
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.SELECT_ALL_CREDIT_MEMO_DEALERS_ON_LOAD
});

export const selectCreditMemoDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_CREDIT_MEMO_DEALER
});



// WEBPACK FOOTER //
// ./src/reports/credit-memo/action-creators/select-dealer.js